import React, { forwardRef } from 'react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  containerClassName?: string;
  labelClassName?: string;
  selectClassName?: string;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      label,
      error,
      helperText,
      containerClassName = '',
      labelClassName = '',
      selectClassName = '',
      id,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`space-y-2 ${containerClassName}`}>
        {label && (
          <label
            htmlFor={id}
            className={`block text-sm font-medium ${labelClassName}`}
            style={{ color: error ? '#E74C3C' : 'var(--patreon-black)' }}
          >
            {label}
          </label>
        )}

        <select
          ref={ref}
          id={id}
          className={`
            block w-full rounded-md shadow-sm
            focus:border-[color:var(--patreon-orange)] focus:ring-[color:var(--patreon-orange)]
            disabled:bg-gray-100
            ${selectClassName}
          `}
          style={{
            background: 'var(--patreon-card-bg)',
            borderColor: error ? '#E74C3C' : 'var(--patreon-card-border)',
            color: 'var(--patreon-black)'
          }}
          {...props}
        >
          {children}
        </select>

        {error && (
          <p className="text-sm" style={{ color: 'var(--patreon-error)' }}>{error}</p>
        )}

        {helperText && !error && (
          <p className="text-sm" style={{ color: 'var(--patreon-gray)' }}>{helperText}</p>
        )}
      </div>
    );
  }
);

Select.displayName = 'Select';

export default Select;



